export default __webpack_public_path__ + "static/media/spaghetti.25a8fec1.svg";